export const REQUIRED_MESSAGE = 'This field is required'

export const TEST_IDS = {
  // Dedicated Lanes Modal
  dedicatedLanesModalLanesPreference: 'dedicated-lanes-preference',
  dedicatedLanesModalRpm: 'rpm-field',
}
